export enum ExperimentFlags {
  PdpOutfitBuilder = 'experiment-pdp-outfit-builder',
}
